var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91,50c0,1.1-0.9,2-2,2H36.7c-0.9,2.9-3.5,5-6.7,5s-5.8-2.1-6.7-5H11c-1.1,0-2-0.9-2-2s0.9-2,2-2h12.3c0.9-2.9,3.5-5,6.7-5   s5.8,2.1,6.7,5H89C90.1,48,91,48.9,91,50z M89,75H56.7c-0.9-2.9-3.5-5-6.7-5s-5.8,2.1-6.7,5H11c-1.1,0-2,0.9-2,2s0.9,2,2,2h32.3   c0.9,2.9,3.5,5,6.7,5s5.8-2.1,6.7-5H89c1.1,0,2-0.9,2-2S90.1,75,89,75z M11,25h52.3c0.9,2.9,3.5,5,6.7,5s5.8-2.1,6.7-5H89   c1.1,0,2-0.9,2-2s-0.9-2-2-2H76.7c-0.9-2.9-3.5-5-6.7-5s-5.8,2.1-6.7,5H11c-1.1,0-2,0.9-2,2S9.9,25,11,25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSlider);
export default __webpack_public_path__ + "static/media/icon-filter-slider.47e005b9.svg";
export { ForwardRef as ReactComponent };